(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const cards = document.querySelectorAll('.card-gallery');

    cards.forEach(card => {
      const wrapper = card.querySelector('[data-lazy-video-wrapper]');
      if (!wrapper) return;

      const template = wrapper.querySelector('.lazy-video-template');
      if (!template) return;

      let loaded = false;

      function loadAndPlayVideo() {
        if (loaded) return;
        loaded = true;

        const videoNode = template.content.cloneNode(true);
        const container = wrapper.querySelector('.product-media');
        container.innerHTML = '';
        container.appendChild(videoNode);

        const video = container.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      }

      // Desktop: load on hover
      card.addEventListener('mouseenter', loadAndPlayVideo, { once: true });

      // Mobile: load on first touch
      card.addEventListener('touchstart', function (e) {
        if (window.innerWidth <= 749) {
          loadAndPlayVideo();

          const secondary = card.querySelector('.secondary-media');
          const primary = card.querySelector('.primary-media');

          if (secondary && primary) {
            secondary.style.opacity = '1';
            primary.style.opacity = '0';
          }
        }
      }, { once: true, passive: true });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
